"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});var e=(r=>(r.info="info",r.error="error",r))(e||{});exports.AnnouncementType=e;
